import * as React from "react";
import { Modal, Button, InputGroup, Form } from "react-bootstrap";
import I18n from "lib/I18n";
import style from "./style.module.css";
import { BsX } from "react-icons/bs";
import { getStore } from "../../store";
import { observer } from "mobx-react-lite";
import { useState } from "react";

interface ChipProps {
  value: string;
  onDelete(value: string): void;
}

const Chip = ({ value, onDelete }: ChipProps) => (
  <span
    className={`chip-hex-data-key ${style.chip}`}
    data-raw-post-hex-data-key={value}
    key={value}
  >
    <span className={style.chipText}>{value}</span>
    <span
      className={`dismiss ${style.dismiss}`}
      onClick={() => onDelete(value)}
    >
      <BsX />
    </span>
  </span>
);

export const ConfigDialog = observer(() => {
  const { config } = getStore();
  const [newHexDataKey, setNewHexDataKey] = useState("");

  const onEventIdExactMatchChange = (e: React.FormEvent<HTMLInputElement>) => {
    e.stopPropagation();
    config.eventIdExactMatch = e.currentTarget.checked;
  };

  const onDisplayIdInHexChange = (e: React.FormEvent<HTMLInputElement>) => {
    e.stopPropagation();
    config.displayIdAsHex = e.currentTarget.checked;
  };

  const onAddHexDataKeyClick = () => {
    setNewHexDataKey("");
    config.hexDataKeys.push(newHexDataKey);
  };

  const onChangeNewHexDataKey = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => setNewHexDataKey(e.currentTarget.value);

  const onClickClose = () => (config.isOpened = false);

  const onClickClearHexDataKey = () => (config.hexDataKeys = []);

  const renderHexDataKeys = () => {
    return config.sortedHexDataKeys.map((key) => (
      <Chip
        value={key}
        key={key}
        onDelete={(key) => config.removeHexDataKey(key)}
      />
    ));
  };

  return (
    <Modal show={config.isOpened} onHide={onClickClose} size="lg">
      <Modal.Header>
        <Modal.Title>Configuration</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Check
          id="checkbox-event-id-exact-match"
          className="checkbox-event-id-exact-match"
          checked={config.eventIdExactMatch}
          onChange={onEventIdExactMatchChange}
          label={I18n.t("event_master_editor.label.event_id_exact_match")}
        />
        {!config.idScrambled && (
          <Form.Check
            id="checkbox-display-id-as-hex"
            className="checkbox-display-id-as-hex"
            checked={config.displayIdAsHex}
            onChange={onDisplayIdInHexChange}
            label={I18n.t("event_master_editor.label.display_id_as_hex")}
          />
        )}
        <Form.Group style={{ width: 500 }}>
          <Form.Label>
            {I18n.t("event_master_editor.label.add_hex_data_key")}
          </Form.Label>
          <InputGroup>
            <Form.Control
              type="text"
              name="newHexDataKey"
              onChange={onChangeNewHexDataKey}
              value={newHexDataKey}
            />
            <Button
              variant="primary"
              onClick={onAddHexDataKeyClick}
              className="button-add-new-hex-data-key"
            >
              {I18n.t("event_master_editor.action.add")}
            </Button>
            <Button onClick={onClickClearHexDataKey}>
              {I18n.t("event_master_editor.action.clear")}
            </Button>
          </InputGroup>
        </Form.Group>
        <div className={`${style.chipWrapper} hex-data-keys`}>
          {renderHexDataKeys()}
        </div>
        <div> {I18n.t("event_master_editor.help.add_hex_data_key")} </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          className="button-close-config"
          onClick={onClickClose}
        >
          {I18n.t("event_master_editor.action.close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
});
